import React, { useEffect } from 'react';
import ModuleContainer from '@/presentation/components/Container';
import SectionHeader from '@/presentation/reusables/SectionHeader';
import ListCategory from '../courses/components/ListCategory';

const ServicesView = (props: any) => {
  const { handlerRedirect, servicesSections, sectionHeader } = props;
  useEffect(() => {
    document.title = `UTP + Portal | Servicios`;
    return () => {
      document.title = `UTP+ Portal | Universidad Tecnológica del Perú`;
    };
  }, []);

  return (
    <ModuleContainer containerType="section">
      <SectionHeader
        title={sectionHeader.title}
        description={sectionHeader.description}
      />
      <ListCategory
        courseSections={servicesSections}
        handleSelectCategory={handlerRedirect}
        testId="cmp-Category-list"
      />
    </ModuleContainer>
  );
};
export default ServicesView;
